import { useTranslations } from "next-intl";
import { useSubscriptionStatus } from "@hooks/use-current-user";
import { usePrice } from "@hooks/use-prices";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";

function SubscriptionRecapCoupon({ currentCoupon }) {
  const t = useTranslations("accounts");

  const subscriptionStatus = useSubscriptionStatus();
  const price = usePrice();

  if (
    [subscriptionStatuses.notSubscribed, subscriptionStatuses.canceled].includes(subscriptionStatus)
  )
    return null;
  if (!currentCoupon) return null;

  const discountValueText = () => {
    if (currentCoupon.type === "coupon_percent_off") {
      return t("manage_subscription.coupon.coupon_percent_off", {
        percent: currentCoupon.value,
      });
    } else {
      return t("manage_subscription.coupon.coupon_amount_off", {
        amount: price(currentCoupon.value, { withoutSpace: true }),
      });
    }
  };

  const discountDurationText = () => {
    switch (currentCoupon.duration) {
      case "once":
        return t("manage_subscription.coupon.once");
      case "forever":
        return t("manage_subscription.coupon.forever");
      case "repeating":
        return t("manage_subscription.coupon.repeating", {
          count: parseInt(currentCoupon.duration_in_months, 10),
        });
      default:
        return null;
    }
  };

  return (
    <p
      className="mb-0"
      data-testid="manage-subscription-recap-coupon-section"
    >
      <span className="text-gray">{t("manage_subscription.coupon.name")}</span>
      <span>{discountValueText()}</span>
      <span>{discountDurationText()}</span>
    </p>
  );
}

export default SubscriptionRecapCoupon;
